import React, { useEffect } from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import { playerStyles } from 'root/src/client/web/commonStyles'
import { twMerge } from 'tailwind-merge'

const PLAYER_EVENT_TYPE = {
	STATE_CHANGE: 'onStateChange',
}

const PLAYER_STATE = {
	ENDED: 0,
	PLAYING: 1,
	PAUSED: 2,
	BUFFERING: 3,
	CUED: 5,
}

const TIKTOK_PLAYER_URL = 'https://www.tiktok.com/player/v1'

const TIKTOK_PLAYER_ORIGIN = 'https://www.tiktok.com'

const isPlayerStateChangedEvent = event => 'data' in event && event.data.type === PLAYER_EVENT_TYPE.STATE_CHANGE

const TikTokPlayer = ({ videoId, classes, completedDare, onPlay }) => {
	const videoUrl = `${TIKTOK_PLAYER_URL}/${videoId}?&music_info=1&description=1`

	const onStart = () => {
		if (onPlay) {
			onPlay()
		}
	}

	const onPlayerStateChange = (event) => {
		if (isPlayerStateChangedEvent(event)) {
			if (event.data.value === PLAYER_STATE.PLAYING) {
				onStart()
			}
		}
	}

	useEffect(() => {
		const onMessage = (event) => {
			if (event.origin !== TIKTOK_PLAYER_ORIGIN) {
				return
			}
			if (isPlayerStateChangedEvent(event)) {
				onPlayerStateChange(event)
			}
		}
		window.addEventListener('message', onMessage)
		return () => {
			window.removeEventListener('message', onMessage)
		}
	}, [])

	return (
		<div
			className={twMerge(classes.iframeContainer, completedDare && classes.completedDareIframeContainer)}
		>
			<iframe
				height="100%"
				width="100%"
				src={videoUrl}
				allow="fullscreen"
				title="test"
				className="border-2"
			/>
		</div>
	)
}

export default withStyles(playerStyles, { name: 'MuiTikTokPlayer' })(
	TikTokPlayer,
)
